import Service from "../../Services";

const Branch = {
    namespaced : true,
    state : {
        branches : [],
        branch_name : 'ALL BRANCHES',
        lang : 'th',
        branch_id : 0,
        tag_name : 'all',
        miniByBranch: null,
        siteMenu: null
    },
    mutations : {
        GET_BRANCH_DATA : (state,res)=>{
            state.branches = res;
        },
        setLang: (state, data) => {
            state.lang = data;
        },
        GET_BRANCH_BY_ID : (state,res)=>{
            state.branch_name = res ? res.branch_name_en : 'ALL BRANCHES';
            state.branch_id = res ? res.branch_id : 0;
            state.tag_name = res.tag_name;
        },
        setMiniByBranch: (state, res) => {
            // state.branch_name = state.branches[4].branch_name;
            // state.branch_id = state.branches[4].branch_id;
            state.miniByBranch = res;
        },
        setSiteLeftMenu: (state, res) => {
            // state.branch_name = state.branches[4].branch_name;
            // state.branch_id = state.branches[4].branch_id;
            state.siteMenu = res;
        }
    },
    actions : {
        getBranchAll({commit},lang='th') {
            return Service.BranchAPI.getBranchAll(lang).then(res=>{
                commit('GET_BRANCH_DATA',res);
            });
        },
        // eslint-disable-next-line no-unused-vars
        getBranchById({commit},id){
            return Service.BranchAPI.getBranchById(id).then(res=>{
                if(res.response_code == 200){
                    commit('GET_BRANCH_BY_ID',res.result);
                }
            });
        },
        getMiniByBranch({commit}, {branch_id, lang}){
            return Service.BranchAPI.getMiniByBranch(branch_id, lang).then(res => {
                if (res) {
                    commit('setMiniByBranch', res);
                }
            });
        },
        getSiteLeftMenu({commit}){
            return Service.BranchAPI.getSiteLeftMenu().then(res => {
                if (res) {
                    commit('setSiteLeftMenu', res);
                }
            });
        },
    },
}
export default Branch
